import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "article-container"
}

import { onMounted, ref } from "vue";
import fetchData from "@/utils/axios";
import { useRoute } from "vue-router";
import Title from "@/components/atoms/Title.vue";
import Text from "@/components/atoms/Text.vue";
import Container from "@/components/layouts/Container.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const backendUrl = process.env.VUE_APP_BACKEND_URL;
const data = ref(null);
const jobs = ref(null);
const error = ref(null);

const route = useRoute();

const postId = ref(route.params.id);

onMounted(async () => {
  try {
    const res = await fetchData("/api/posts", {
      filters: {
        id: {
          $eq: postId.value,
        },
      },
    });

    data.value = res.data.data[0].attributes;
  } catch (err) {
    error.value = err;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_VueShowdown = _resolveComponent("VueShowdown")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Container, { size: "large" }, {
      default: _withCtx(() => [
        (data.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(Title, {
                color: "dark",
                size: "medium"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.value.Title), 1)
                ]),
                _: 1
              }),
              _createVNode(Text, { class: "markdown" }, {
                default: _withCtx(() => [
                  _createVNode(_component_VueShowdown, {
                    markdown: data.value.Content,
                    flavor: "github"
                  }, null, 8, ["markdown"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})